// extracted by mini-css-extract-plugin
export default {"searchResultPageSpan":"searchResultPage_searchResultPageSpan__pTik7","noResultDiv":"searchResultPage_noResultDiv__WzPFN","searchContainer":"searchResultPage_searchContainer__tE--3"};